/*
 * Routes-orders.ts
 * Description: Includes the declaration of the
 * orders routes for Vue Router
 */

// Importing components
import PageDeliveryOrders from '@/pages/orders/PageDeliveryOrders.vue';
import PageOrders from '@/pages/orders/PageOrders.vue';
import PageUserOrders from '@/pages/profile/PageUserOrders.vue';

const routesOrders = [
    // Defining the login page route
    {
        path: '/orders',
        name: 'orders',
        component: PageUserOrders,
        meta: { requiresAuth: true },
    },
    // Defining the orders page route
    {
        path: '/restaurants/:id/orders/manage',
        name: 'orders-manage',
        component: PageOrders,
        props: { id: Number },
        meta: { requiresAuth: true, ManageOrders: true },
    },
    // Defining the orders page route
    {
        path: '/restaurants/:id/orders/delivery',
        name: 'orders-delivery',
        component: PageDeliveryOrders,
        props: { id: Number },
        meta: { requiresAuth: true, ManageDeliveries: true },
    },
];
export default routesOrders;
